import { mapResponsiveProps } from '@codex-brightworld/gadgets';
import { FlexBox as FB, FlexItem as FI } from './Flex';

export const FlexBox = mapResponsiveProps(FB);
export const FlexItem = mapResponsiveProps(FI);
